export const primary = '#1f3164'
export const secondary = '#FF6A3D'
export const accent = '#F4DB7D'
export const light = 'rgba(0, 0, 0, 0.125)'

export default {
  primary,
  secondary,
  accent,
  light
}
